import { Grid } from "@mui/material";
import { useEffect } from "react";
import TallerAprendizajeCardImg from "../../components/UmmIApps/Cards/TallerAprendizajeCardImg.png";
//import { Button } from '@aws-amplify/ui-react';
import CantidadSesionesTaller from "../../components/Form/Fields/CantidadSesionesTaller";
import ConocimientosPrevios from "../../components/Form/Fields/ConocimientosPrevios";
import DuracionTaller from "../../components/Form/Fields/DuracionTaller";
import FormatoTaller from "../../components/Form/Fields/FormatoTaller";
import NumeroParticipantesTaller from "../../components/Form/Fields/NumeroParticipantesTaller";
import ObjetivoTaller from "../../components/Form/Fields/ObjetivoTaller";
import PublicoObjetivo from "../../components/Form/Fields/PublicoObjetivo";
import TemaTaller from "../../components/Form/Fields/TemaTaller";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";

const TallerAprendizajePage = () => {
  const { handleBack, setTextoInicial, promptData, handleInitialPromptData } =
    useActividadesContext();

  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled = !(
    promptData.tema_taller &&
    promptData.objetivo_taller &&
    promptData.conocimientos_previos &&
    promptData.formato_taller &&
    promptData.cantidad_sesiones_taller &&
    promptData.duracion_taller &&
    promptData.numero_participantes_taller &&
    promptData.publico_objetivo
  );
  const colorIconBack = "#8B3355";

  useEffect(() => {
    const init = {
      tema_taller: "",
      objetivo_taller: "",
      conocimientos_previos: "",
      formato_taller: "",
      cantidad_sesiones_taller: 1,
      duracion_taller: 1,
      numero_participantes_taller: 1,
      publico_objetivo: "",
    };
    handleInitialPromptData(init, "taller_aprendizaje");
    setTextoInicial(
      "Esta es la propuesta que tengo para ti. Puedes revisarla y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={TallerAprendizajeCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #E8D6DD 50%, #A25C77 100%)"
        }
        titleColor="#8B3355"
        title="Taller de aprendizaje"
        description="Elabora un taller detallado que te permita colaborar con tus colegas en un tema que sea de interés y que fomente el crecimiento profesional"
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid item xs={12}>
          <TemaTaller />
        </Grid>
        <Grid item xs={12}>
          <ObjetivoTaller />
        </Grid>
        <Grid item xs={12}>
          <ConocimientosPrevios />
        </Grid>
        <Grid item xs={12}>
          <FormatoTaller />
        </Grid>
        <Grid item xs={12}>
          <CantidadSesionesTaller />
        </Grid>
        <Grid item xs={12}>
          <DuracionTaller />
        </Grid>
        <Grid item xs={12}>
          <NumeroParticipantesTaller />
        </Grid>
        <Grid item xs={12}>
          <PublicoObjetivo />
        </Grid>
      </UmmiaAppsLayout>
    </>
  );
};

export default TallerAprendizajePage;
